import { Grid, Typography, Divider, Box, Card, CardContent, Collapse, CardHeader } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import WarningIcon from '@mui/icons-material/Warning';
import DangerousIcon from '@mui/icons-material/Dangerous';
import '../../../styles/report.css'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"


const KeyAreaSmallCard = (props) => {
    const [PrintView, setPrintView] = useState(false)
    useEffect(() => { setPrintView(props.PrintView) }, [props.PrintView])

    const [value, setValue] = React.useState(0);
    const [currentTab, setCurrentTab] = React.useState(props.smallCard)
    const [isFlipped, setIsFlipped] = React.useState(false)
    const [isFlippedLarge, setIsFlippedLarge] = React.useState(false)

    // const handleChange = (event, newValue) => {
    //     setValue(newValue);
    //     setIsFlipped(-1)
    //     setCurrentTab(props.cards.KeyAreas.KeyAreaArray[newValue])
    // };

    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }

    const getColorBottomCard = (valuegrade, opacity) => {
        if (valuegrade == "1") return { background: 'linear-gradient(to bottom, #fff, #fff 92%, rgba(78, 183, 72,' + opacity + ') 175%)', color: 'black', minHeight: '50px' }
        if (valuegrade == "2") return { background: 'linear-gradient(to bottom, #fff, #fff 92%, rgba(231, 198, 30,' + opacity + ') 175%)', color: 'black', minHeight: '50px' }
        else return { background: 'linear-gradient(to bottom, #fff, #fff 92%, rgba(230, 50, 58,' + opacity + ') 175%)', color: 'black', minHeight: '50px' }
    }

    const getColorBottomHeader = (valuegrade, opacity) => {
        if (valuegrade == "1") return { background: 'linear-gradient(to bottom, #fff, #fff 95%, rgba(78, 183, 72,' + opacity + ') 95%, rgba(78, 183, 72,' + opacity + ') 100%)', color: 'black', minHeight: '50px' }
        if (valuegrade == "2") return { background: 'linear-gradient(to bottom, #fff, #fff 95%, rgba(231, 198, 30,' + opacity + ') 95%, rgba(231, 198, 30,' + opacity + ') 100%)', color: 'black', minHeight: '50px' }
        else return { background: 'linear-gradient(to bottom, #fff, #fff 95%, rgba(230, 50, 58,' + opacity + ') 95%, rgba(230, 50, 58,' + opacity + ') 100%)', color: 'black', minHeight: '50px' }
    }


    const getColorDivider = (valuegrade, opacity) => {
        if (valuegrade == "1") return { borderColor: 'linear-gradient(to right bottom, rgba(78, 183, 72,0.8), rgba(78, 183, 72,0.15))', borderRadius: '90%', borderBottomWidth: 2 }
        if (valuegrade == "2") return { borderColor: 'linear-gradient(to right bottom, rgba(231, 198, 30,0.8), rgba(231, 198, 30,0.15))', borderRadius: '90%', borderBottomWidth: 2 }
        else return { borderColor: 'linear-gradient(to right bottom, rgba(230, 50, 58,0.8),rgba(230, 50, 58,0.15))', borderRadius: '90%', borderBottomWidth: 2 }
    }


    const getIcon = (valuegrade) => {
        if (valuegrade == "1") return <HealthAndSafetyIcon sx={{ color: '#4eb748' }} />
        if (valuegrade == "2") return <WarningIcon sx={{ color: '#E7C61E' }} />
        else return <DangerousIcon sx={{ color: '#E6323A' }} />
    }


    const getShadowSmall = (valuegrade, opacity) => {
        if (valuegrade == "1") return { boxShadow: '2px 5px 15px -3px rgba(78, 183, 72,0.25)' }
        if (valuegrade == "2") return { boxShadow: '2px 5px 15px -3px rgba(231, 198, 30,0.25)' }
        else return { boxShadow: '2px 5px 15px -3px rgba(230, 50, 58,0.25)' }
    }



    if (props.smallCard) {
        return (

            <Grid item md={4} xs={6}>

                <motion.div variants={PrintView === true ? {} : motionVariants} initial="hidden" animate="show" whileHover={{ scale: 1.1 }} style={{ height: '100%' }}>
                    <Card sx={[
                        //getShadowSmall(currentTab.ValueGrade), 
                        { border: 0.1, height: '100%', borderColor: "rgba(0,0,0,0.15)" }, getColorBottomCard(currentTab.ValueGrade, "0.6")]} onClick={() => setIsFlipped(!isFlipped)}>
                        <CardHeader
                            action={
                                getIcon(currentTab.ValueGrade)
                            }
                            title={<Typography fontStyle="bold" sx={{ fontSize: '1rem' }}>{currentTab.CardTitle}</Typography>}
                            disableTypography='true'
                            style={getColorBottomHeader(currentTab.ValueGrade, "1")}
                        >

                        </CardHeader>

                        <CardContent >
                            <Typography variant="body2" color="text.secondary" gutterBottom={true} >
                                <b>{currentTab.YouValueLabel}: {currentTab.YouValue}</b><br />
                                {currentTab.GoalValueLabel}: {currentTab.GoalValue}
                            </Typography>
                            <Box my={2}>
                                <Divider orientation='horizontal' sx={[{ m: 2 }, getColorDivider(currentTab.ValueGrade, 1)]} />
                                <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
                                    {currentTab.BackContent}
                                </Typography>
                            </Box>


                        </CardContent >

                    </Card>
                </motion.div>

            </Grid>
            // ))}


        )
    } else {
        return (<Box></Box>)
    }
}


export default KeyAreaSmallCard;